module.exports = __webpack_public_path__ + "static/media/recommendation_high_risk.9f77f1a5.svg";